module.exports = __webpack_public_path__ + "img/m_p.4daffe27.png";